import React = require("react");
import i18next from 'i18next';
import { DependencyData, FieldData, StepData } from "../../../form/types";
import moment from "moment"
import { Answer } from "../../../../generated_models";
import { getJobFunctionData, getThemeData } from "./beslismatrixWizardApi";

export let getStep2Data = (): StepData[] => {

    let jobFunctionData: string[] = getJobFunctionData()

    let themeData: string[] = getThemeData()

    let subscriptionOptionData: string[] = [
        "1 jaar",
        "2 jaar",
        "3 jaar of meer"
    ]

    // let learningCurveOptionData: string[] = [
    //     "Formeel 70%",
    //     "Informeel 20%",
    //     "Non-formeel 10%"
    // ]

    let mk_q1 = () => {
        let fieldId: number = 4
        let fieldAnswers: Answer[] = jobFunctionData.map(
            (a, i) => (
                {
                    Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "", nested_fields: [],
                    shouldSelectAllAnswers: a.toLowerCase() == i18next.t("Tab2.Q1_All_Job_Functions").toLowerCase()
                }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "CheckboxMultiSelect", itemOrderNumber: 1, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab2.Q1'), width_percentage: "Large", label: 'Tab2.Q1', ExtraClassName: "round"
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            nested_fields: [],
            user_input: undefined
        }
        return fieldData
    }
    let f1 = mk_q1()

    let mk_q2 = () => {
        let fieldId: number = 5
        let fieldAnswers: Answer[] = themeData.map(
            (a, i) => (
                {
                    Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "", nested_fields: [],
                    shouldSelectAllAnswers: a.toLowerCase() == i18next.t("Tab2.Q2_All_Themes").toLowerCase()
                }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "CheckboxMultiSelect", itemOrderNumber: 2, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab2.Q2'), width_percentage: "Large", label: 'Tab2.Q2', ExtraClassName: "round"
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            nested_fields: [],
            user_input: undefined
        }
        return fieldData
    }
    let f2 = mk_q2()

    // let mk_q3 = () => {
    //     let fieldId: number = 6
    //     let fieldAnswers: Answer[] = learningCurveOptionData.map((a, i) => ({ Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "" }))
    //     let fieldData: FieldData = {
    //         field: {
    //             Id: fieldId, CreatedDate: moment(), Kind: "RadioOption", itemOrderNumber: 3, description: "", optionalDefaultValue: "",
    //             title: i18next.t('Tab2.Q3'), width_percentage: "Large", label: 'Tab2.Q3', ExtraClassName: "square"
    //         },
    //         maybe_answers: fieldAnswers,
    //         maybe_labels: [],
    //         user_input: fieldAnswers[0].value
    //     }
    //     return fieldData
    // }
    // let f3 = mk_q3()

    let mk_q4 = () => {
        let fieldId: number = 7
        let fieldAnswers: Answer[] = subscriptionOptionData.map((a, i) => ({ Id: +`${fieldId}${i}`, CreatedDate: moment(), isDefaultSelected: false, value: a, label: "" }))
        let fieldData: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "RadioOption", itemOrderNumber: 4, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab2.Q4'), width_percentage: "Large", label: 'Tab2.Q4', ExtraClassName: "square"
            },
            maybe_answers: fieldAnswers,
            maybe_labels: [],
            user_input: fieldAnswers[0].value
        }
        return fieldData
    }
    let f4 = mk_q4()

    let mk_dependency_filled = () => {
        let dependency_filledId: number = 2
        let dependency_filled_data: DependencyData = {
            is_met: false,
            dependency: { CreatedDate: moment(), Id: dependency_filledId, Kind: "Filled", hideIfViolated: false, title: i18next.t('form.dep_filled'), lockSubmissionIfViolated: true },
            dependent_fields: [{ FieldId: f1.field.Id }, { FieldId: f2.field.Id }, { FieldId: f4.field.Id }] //{ FieldId: f3.field.Id }, 
        }
        return dependency_filled_data
    }

    let dependency_filled = mk_dependency_filled()
    let dependency_list: DependencyData[] = [dependency_filled]

    let field_list: FieldData[] = [f1, f2, f4] //f3, question not included for now

    let step_2 = (): StepData => {

        return {
            dependencies: dependency_list,
            fields: field_list,
            step: { Id: 2, CreatedDate: moment(), orderNumber: 2, title: i18next.t('Tab2.Title') },
        }
    }

    return [step_2()]
}